import { TimeLabel } from '#src/components/labels/TimeLabel/index.tsx';
import { TimeLeft } from '#src/contexts/ticker/TimeLeft/index.tsx';

type Props = {
  deadline: Date;
};

export const ReferrerCodeCountdownChip = ({ deadline }: Props) => {
  return (
    <TimeLabel color="red" state="countdown">
      <TimeLeft time={deadline} />
    </TimeLabel>
  );
};
